import {
    NOTES_CREATE_EDIT_OPEN_MODAL,
    NOTES_GET_NOTE_REQUEST,
    NOTES_GET_NOTE_RESULT,
    NOTES_CREATE_REQUEST,
    NOTES_CREATE_RESULT,
    NOTES_UPDATE_REQUEST,
    NOTES_UPDATE_RESULT,
} from 'Redux/actionTypes';


export const notesCreateEditOpenModal = (id, show) => ({
    type: NOTES_CREATE_EDIT_OPEN_MODAL,
    payload: {id, show}
})

export const notesCreateRequest = (data) => ({
    type: NOTES_CREATE_REQUEST,
    payload: data
})

export const notesCreateResult = (result) => ({
    type: NOTES_CREATE_RESULT,
    payload: result
})

export const notesUpdateRequest = (data) => ({
    type: NOTES_UPDATE_REQUEST,
    payload: data
})

export const notesUpdateResult = (data) => ({
    type: NOTES_UPDATE_RESULT,
    payload: data
})

export const notesGetNoteRequest = (data) => ({
    type: NOTES_GET_NOTE_REQUEST,
    payload: data
})

export const notesGetNoteResult = (data) => ({
    type: NOTES_GET_NOTE_RESULT,
    payload: data 
})